import { cva } from "class-variance-authority";

/**
 * Typography scale for the `Text` primitive. Three independent axes:
 *  - `size`   — the type scale (Tailwind's built-in font-size utilities)
 *  - `weight` — the font-weight scale
 *  - `variant`— semantic color, aliased to the live Telegram theme tokens
 *
 * Sizes use Tailwind's standard `text-xs/sm/base` (14px body, 12px caption,
 * 16px subtitle) so they always resolve correctly. Defaults reproduce the
 * previous "body, normal, default-color" look, so every call site renders
 * identically.
 */
export const textVariants = cva("text-tg-text", {
  variants: {
    size: {
      caption: "text-[0.8rem]", // 12px
      body: "text-sm", // 14px — default body text
      subtitle: "text-base", // 16px
      title: "text-2xl",
    },
    weight: {
      normal: "font-normal",
      medium: "font-medium",
      semibold: "font-semibold",
      bold: "font-bold",
    },
    variant: {
      default: "",
      sub: "text-tg-subtitle",
      hint: "text-tg-hint",
      accent: "text-tg-accent",
      danger: "text-tg-destructive",
      // Telegram injects no warning color, so this rides the fixed status token
      // rather than a `--tg-theme-*` var.
      warning: "text-warning",
      link: "text-tg-link",
    },
  },
  defaultVariants: {
    size: "body",
    weight: "normal",
    variant: "default",
  },
});
